/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:42:35
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-28 14:03:58
 * @Description:
 * @Developer:
 */
import { Breadcrumb, Button, theme } from 'antd';
import { Content } from 'antd/es/layout/layout';
import React, { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
export default function AdminPage(props) {
    var _a;
    const { token: { colorBgContainer } } = theme.useToken();
    const navigate = useNavigate();
    return (React.createElement(Fragment, null,
        React.createElement(Breadcrumb, { style: { margin: '16px 0' } }, (_a = props.breadcrumbs) === null || _a === void 0 ? void 0 : _a.map((item, index) => (React.createElement(Breadcrumb.Item, { key: index, onClick: () => navigate(item.url) },
            React.createElement(Button, { type: 'text', size: 'small' }, item.label))))),
        React.createElement(Content, { style: {
                // padding: 12,
                margin: 0,
                height: '100%',
                overflow: 'scroll'
                // background: colorBgContainer,
            } }, props.children)));
}
